module.exports = {
  "name": "home-ui",
  "version": "25.05.02",
  "private": true,
  "dependencies": {
    "@auth0/auth0-react": "^2.1.0",
    "@hookform/resolvers": "^2.5.2",
    "@lwt-common/http-service": "^2.0.1",
    "@lwt-helix/alert": "^2.3.0",
    "@lwt-helix/buttons": "^1.6.2",
    "@lwt-helix/card": "^2.3.1",
    "@lwt-helix/client-switcher": "^1.3.0",
    "@lwt-helix/collapse": "^1.0.2",
    "@lwt-helix/core": "^1.0.1",
    "@lwt-helix/dead-end": "^1.1.0",
    "@lwt-helix/dropdown": "^3.4.0",
    "@lwt-helix/form-schema": "^3.3.7",
    "@lwt-helix/icon": "^1.2.0",
    "@lwt-helix/layout": "^1.0.3",
    "@lwt-helix/loader": "^1.0.1",
    "@lwt-helix/modal": "^1.4.1",
    "@lwt-helix/navbar": "^2.2.0",
    "@lwt-helix/page": "^1.6.1",
    "@lwt-helix/schema-table": "6.12.4",
    "@lwt-helix/select": "^1.1.0",
    "@lwt-helix/slideout-panel": "^1.10.1",
    "@lwt-helix/sticky-footer": "^1.2.1",
    "@lwt-helix/tab": "^1.4.4",
    "@lwt-helix/tooltip": "^1.2.1",
    "@microsoft/applicationinsights-web": "^2.6.3",
    "@popperjs/core": "^2.9.2",
    "autoprefixer": "^10.2.5",
    "axios": "^0.21.1",
    "classnames": "^2.2.6",
    "core-js": "^3.42.0",
    "create-react-app-parcel-typescript": "0.0.5",
    "date-fns": "2.22.1",
    "email-validator": "^2.0.4",
    "immutable": "^3.8.2",
    "jsonwebtoken": "^9.0.0",
    "lodash": "^4.17.15",
    "mathjs": "^9.3.0",
    "parcel-bundler": "^1.12.5",
    "parcel-plugin-static-files-copy": "^2.6.0",
    "prop-types": "^15.7.2",
    "qs": "^6.9.1",
    "react": "^17.0.2",
    "react-dom": "^17.0.2",
    "react-helmet": "^6.1.0",
    "react-hook-form": "^7.8.4",
    "react-lightweight-tooltip": "^1.0.0",
    "react-modal": "^3.14.2",
    "react-redux": "^7.2.4",
    "react-router-dom": "5.2.0",
    "react-select": "^4.0.2",
    "react-toastify": "^7.0.4",
    "react-tooltip": "^4.2.21",
    "redux": "^4.1.0",
    "redux-form": "^8.3.7",
    "redux-logger": "^3.0.6",
    "redux-thunk": "^2.3.0",
    "regenerator-runtime": "^0.14.1",
    "yup": "^0.32.9"
  },
  "comments": {
    "parcel-weirdness": [
      "parcel has a bug that causes it to choke on the minified dist of auth0-react,",
      "the postinstall script is a workaround from https://github.com/auth0/auth0-spa-js/issues/427",
      "This only affects the development build i.e. yarn start; yarn build && serve -s dist works fine but you lose dev tools"
    ]
  },
  "scripts": {
    "postinstall": "sed -i.bak \"s/sourceMappingURL=\"/source\"+\"MappingURL=\"/\" node_modules/@auth0/auth0-react/dist/*.js && sed -i.bak \"s/sourceMappingURL=\"/source\"+\"MappingURL=\"/\" node_modules/@auth0/auth0-spa-js/dist/*.js",
    "generate-build-version": "node generate-build-version",
    "prebuild": "npm run generate-build-version",
    "start": "react-scripts-parcel start",
    "build": "react-scripts-parcel build",
    "test": "jest --coverage",
    "eject": "react-scripts-parcel eject"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@babel/core": "^7.0.0-0",
    "@babel/plugin-transform-runtime": "^7.27.1",
    "@babel/preset-env": "^7.27.2",
    "@babel/preset-react": "^7.27.1",
    "@jest/globals": "latest",
    "@testing-library/react": "^11.2.6",
    "acorn": "^6.0.0",
    "axios-mock-adapter": "^1.17.0",
    "babel-core": "^6.26.3",
    "babel-eslint": "^10.1.0",
    "babel-jest": "^26.6.3",
    "babel-plugin-file-loader": "^2.0.0",
    "browserslist": "^4.8.6",
    "enzyme": "^3.11.0",
    "enzyme-adapter-react-16": "^1.15.2",
    "enzyme-to-json": "^3.6.2",
    "eslint": "^7.23.0",
    "eslint-plugin-react": "^7.23.1",
    "eslint-plugin-react-hooks": "^4.2.0",
    "identity-obj-proxy": "^3.0.0",
    "istanbul": "^0.4.5",
    "jest": "^26.6.3",
    "jest-environment-jsdom-sixteen": "^1.0.3",
    "jsdom": "^16.5.2",
    "moxios": "^0.4.0",
    "react-test-renderer": "^16.12.0",
    "redux-mock-store": "^1.5.4",
    "sed": "^0.0.2",
    "sinon": "^8.1.1",
    "ts-jest": "^26.5.4",
    "typescript": "^4.2.3"
  }
}
;